import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadReport from '../_shared/DownloadReport';
import ReportServicesData from './ReportServicesData';
import ReportFiltersBar from './ReportFiltersBar';
import ReportCategoriesBar from './ReportCategoriesBar';
import SideBar from '../_shared/SideBar';
import TitleContainer from '../_shared/TitleContainer';

const DEFAULT_SERVICE_CATEGORIES = (process.env.REACT_APP_SERVICE_CATEGORIES || '')
  .split(',')
  .map(Number)
  .filter(categoryId => Number.isInteger(categoryId) && categoryId > 0);

const ReportServices = () => {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState([]);
  const [queryFilters, setQueryFilters] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState(true);

  return (
      <div className='page-wrapper'>
        <SideBar setQueryFilters={setQueryFilters} isLoading={isLoading} filtersData={filtersData} setFiltersData={setFiltersData} cumulativeField={true} cumulativeFieldValue={true} categories={true} categoriesArr={DEFAULT_SERVICE_CATEGORIES} cumulativeDisabled={false} timePeriod={false} trend={true} workshop={2} />
        <TitleContainer text={t('reportServices')}>
          <DownloadReport disabled={noData} reportType={10} />
        </TitleContainer>
        <ReportFiltersBar filtersData={filtersData} queryFilters={queryFilters} noTimePeriod={true} timePeriod={false} trend={true} />
        <ReportCategoriesBar />
        <ReportServicesData queryFilters={queryFilters} isLoading={isLoading} setIsLoading={setIsLoading} noData={noData} setNoData={setNoData} />
      </div>
  );
};

export default ReportServices;
